<template>
    <v-container fluid style="color:grey" class="policeLato">
      <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
      <section v-if="isDesktop()">
        <div class="mt-5 pt-5 paralax-cover-image has-background-dim">
          <p class="paralax-cover-image-text">
          <div class="content_home" style="z-index: 1!important;">
            <h1 style="font-size: 70px" class="font-weight-bold"><span style="color: #fff">{{ $t('infos_legale.insurance_simply_label[0]') }}</span></h1>
            <h1 style="font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">{{ $t('infos_legale.insurance_simply_label[1]') }}</span></h1>
          </div>
          </p>
        </div>
      </section>

      <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
      <section class="mt-5" v-if="isMobile()">
        <div class="paralax-cover-image_mobile has-background-dim_mobile">
          <p class="paralax-cover-image-text_mobile">
          <div class="content_home" style="z-index: 1!important;margin-top: 20%">
            <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">{{ $t('infos_legale.insurance_simply_label[0]') }}</span></h1>
            <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{ $t('infos_legale.insurance_simply_label[1]') }}</span></h1>
          </div>
          </p>
        </div>
      </section>

        <!--Notre histoire-->
        <v-layout row wrap pa-5 class="align-end justify-content-around policeLato">
            <v-flex xs12 sm12 md12 lg12 pa-2>
                <p class="headline policeLato font-weight-bold" style="text-align:center;color:#59595B">{{ $t('infos_legale.mention_legale_title') }}</p>
            </v-flex>

            <v-flex xs12 sm12 md7 lg7 pa-2>
                <p class="headline text-assuraf policeLato pl-md-5 pt-3"><i class="title-border"></i>{{ $t('infos_legale.informations_legale_label') }}
                </p>
                <p class="text-justify subheading font-weight-regular">
                    <span>ASSURAF</span> {{ $t('infos_legale.informations_legale_content[0]') }} <span>ASSURAF SAS</span>. {{ $t('infos_legale.informations_legale_content[1]') }} 
                    <a href="https://www.assuraf.com">www.assuraf.com</a> {{ $t('infos_legale.informations_legale_content[2]') }} <span>ASSURAF SAS</span>, {{ $t('infos_legale.informations_legale_content[3]') }} <span>{{ $t('infos_legale.informations_legale_content[4]') }}</span> {{ $t('infos_legale.informations_legale_content[5]') }} <span>ASSURAF SAS</span> {{ $t('infos_legale.informations_legale_content[6]') }}
                </p>
                <p class="text-justify subheading font-weight-regular">
                    {{ $t('infos_legale.informations_legale_content[7]') }} <a href="https://www.assuraf.com">www.assuraf.com</a> {{ $t('infos_legale.informations_legale_content[8]') }} <br>
                </p>
            </v-flex>

            <v-flex xs12 sm12 md7 lg7 pa-2>
                <p class="headline text-assuraf policeLato pl-md-5 pt-3"><i class="title-border"></i>{{ $t('infos_legale.redaction_label') }}</p>
                <p class="text-justify subheading font-weight-regular">
                    {{ $t('infos_legale.redaction_content[0]') }} <span>ASSURAF SAS</span> <br>
                    {{ $t('infos_legale.redaction_content[1]') }} <br>
                    {{ $t('infos_legale.redaction_content[2]') }} : <a href="mailto:contact@assuraf.com">contact@assuraf.com</a> <br>
                    {{ $t('infos_legale.redaction_content[3]') }}
                    <span>ASSURAF SAS</span>
                </p>
            </v-flex>

            <v-flex xs12 sm12 md7 lg7 pa-2>
                <p class="headline text-assuraf policeLato pl-md-5 pt-3"><i class="title-border"></i>{{ $t('infos_legale.propriete_label') }}</p>
                <p class="text-justify subheading font-weight-regular">
                    {{ $t('infos_legale.propriete_content[0]') }}<br><br> {{ $t('infos_legale.propriete_content[1]') }} <br><br> 
                    {{ $t('infos_legale.propriete_content[2]') }} d'<span>Assuraf</span> {{ $t('infos_legale.propriete_content[3]') }}<br><br> 
                    {{ $t('infos_legale.propriete_content[4]') }} <span>ASSURAF</span> {{ $t('infos_legale.propriete_content[5]') }} <span>ASSURAF SAS</span>. 
                    {{ $t('infos_legale.propriete_content[6]') }} <span>ASSURAF SAS</span>.

                </p>
            </v-flex>

            <v-flex xs12 sm12 md7 lg7 pa-2>
                <p class="headline text-assuraf policeLato pl-md-5 pt-3"><i class="title-border"></i>{{ $t('infos_legale.contenu_acces_label') }}</p>
                <p class="text-justify subheading font-weight-normal">
                    <span>ASSURAF</span> {{ $t('infos_legale.contenu_acces_content[0]') }}<br><br> {{ $t('infos_legale.contenu_acces_content[1]') }} <span>{{ $t('infos_legale.contenu_acces_content[2]') }}</span>
                    {{ $t('infos_legale.contenu_acces_content[3]') }} <a
                        href="https://www.assuraf.com">www.assuraf.com</a> {{ $t('infos_legale.contenu_acces_content[4]') }}
                    <br><br>
                    {{ $t('infos_legale.contenu_acces_content[5]') }}
                <ul>
                    <li>{{ $t('infos_legale.contenu_acces_content[6]') }} <a href="https://www.assuraf.com">www.assuraf.com</a> {{ $t('infos_legale.contenu_acces_content[7]') }}
                    </li>
                    <li>{{ $t('infos_legale.contenu_acces_content[8]') }}</li>
                    <li>{{ $t('infos_legale.contenu_acces_content[9]') }}</li>
                    <li>{{ $t('infos_legale.contenu_acces_content[10]') }} (<a href="mailto:contact@assuraf.com">contact@assuraf.com</a>)</li>
                    <li>{{ $t('infos_legale.contenu_acces_content[11]') }} (76 141 64 64).</li>
                </ul>
                {{ $t('infos_legale.contenu_acces_content[12]') }}
                </p>
            </v-flex>

            <v-flex xs12 sm12 md7 lg7 pa-2>
                <p class="headline text-assuraf policeLato pl-md-5 pt-3"><i class="title-border"></i>{{ $t('infos_legale.collecte_donnee_label') }}</p>
                <p class="text-justify subheading font-weight-normal">
                    {{ $t('infos_legale.collecte_donnee_content[0]') }} <br><br> {{ $t('infos_legale.collecte_donnee_content[1]') }} <strong>{{ $t('infos_legale.collecte_donnee_content[2]') }}</strong> 
                    {{ $t('infos_legale.collecte_donnee_content[3]') }} <br><br>
                    {{ $t('infos_legale.collecte_donnee_content[4]') }} <br><br>
                    {{ $t('infos_legale.collecte_donnee_content[5]') }} <span>ASSURAF</span>. 
                    {{ $t('infos_legale.collecte_donnee_content[6]') }} <br><br>
                    <ul>
                    <li>{{ $t('infos_legale.collecte_donnee_content[7]') }}</li>
                    <li>{{ $t('infos_legale.collecte_donnee_content[8]') }}</li>
                    <li>{{ $t('infos_legale.collecte_donnee_content[9]') }}
                    </li>
                    <li>{{ $t('infos_legale.collecte_donnee_content[10]') }}</li>
                    <li>{{ $t('infos_legale.collecte_donnee_content[11]') }}
                    </li>
                    <li>{{ $t('infos_legale.collecte_donnee_content[12]') }} ({{ $t('infos_legale.collecte_donnee_content[13]') }} <span>{{ $t('infos_legale.collecte_donnee_content[14]') }}</span>)
                    </li>
                    <li>{{ $t('infos_legale.collecte_donnee_content[15]') }} ({{ $t('infos_legale.collecte_donnee_content[16]') }}
                        <span>{{ $t('infos_legale.collecte_donnee_content[17]') }}</span>).
                    </li>
                </ul>

                    {{ $t('infos_legale.collecte_donnee_content[18]') }} <span>ASSURAF SAS</span> {{ $t('infos_legale.collecte_donnee_content[19]') }} 
                    <span>ASSURAF SAS</span> {{ $t('infos_legale.collecte_donnee_content[20]') }} <br><br>
                    {{ $t('infos_legale.collecte_donnee_content[21]') }} <span>ASSURAF</span> {{ $t('infos_legale.collecte_donnee_content[22]') }} <br><br>

                    {{ $t('infos_legale.collecte_donnee_content[23]') }} <span>ASSURAF</span> {{ $t('infos_legale.collecte_donnee_content[24]') }} <span>ASSURAF</span> {{ $t('infos_legale.collecte_donnee_content[25]') }} <br><br>
                    {{ $t('infos_legale.collecte_donnee_content[26]') }} 
                    <span>{{ $t('infos_legale.collecte_donnee_content[27]') }}</span> {{ $t('infos_legale.collecte_donnee_content[28]') }} <strong>{{ $t('infos_legale.collecte_donnee_content[29]') }}</strong>. {{ $t('infos_legale.collecte_donnee_content[30]') }} <span>{{ $t('infos_legale.collecte_donnee_content[31]') }}</span> {{ $t('infos_legale.collecte_donnee_content[32]') }} <br><br>
                    {{ $t('infos_legale.collecte_donnee_content[33]') }} <span>{{ $t('infos_legale.collecte_donnee_content[34]') }}</span> {{ $t('infos_legale.collecte_donnee_content[35]') }} <span>{{ $t('infos_legale.collecte_donnee_content[36]') }}</span>. 
                    {{ $t('infos_legale.collecte_donnee_content[37]') }} <span>ASSURAF</span> {{ $t('infos_legale.collecte_donnee_content[38]') }} <strong>{{ $t('infos_legale.collecte_donnee_content[39]') }} <a
                    href="https://www.assuraf.com">www.assuraf.com</a>.</strong>
                </p>
            </v-flex>

            <v-flex xs12 sm12 md7 lg7 pa-2>
                <p class="headline text-assuraf policeLato pl-md-5 pt-3"><i class="title-border"></i>{{ $t('infos_legale.cookies_label') }}</p>
                <p class="text-justify subheading font-weight-normal">
                    {{ $t('infos_legale.cookies_content[0]') }} <span>{{ $t('infos_legale.cookies_content[1]') }}</span>.
                    {{ $t('infos_legale.cookies_content[2]') }} <span>{{ $t('infos_legale.cookies_content[3]') }}</span> {{ $t('infos_legale.cookies_content[4]') }} <span>{{ $t('infos_legale.cookies_content[5]') }}</span>
                    {{ $t('infos_legale.cookies_content[6]') }}.
                    {{ $t('infos_legale.cookies_content[7]') }} <span>{{ $t('infos_legale.cookies_content[8]') }}</span>.
                </p>
            </v-flex>

            <v-flex xs12 sm12 md7 lg7 pa-2>
                <p class="headline text-assuraf policeLato pl-md-5 pt-3"><i class="title-border"></i>{{ $t('infos_legale.liens_label') }}</p>
                <p class="text-justify subheading font-weight-normal">
                    {{ $t('infos_legale.liens_content[0]') }}
                </p>
            </v-flex>

            <v-flex xs12 sm12 md7 lg7 pa-2>
                <p class="headline text-assuraf policeLato pl-md-5 pt-3"><i class="title-border"></i>{{ $t('infos_legale.droit_acces_label') }}</p>
                <p class="text-justify subheading font-weight-normal">
                    {{ $t('infos_legale.droit_acces_content[0]') }} <strong>{{ $t('infos_legale.droit_acces_content[1]') }}</strong> {{ $t('infos_legale.droit_acces_content[2]') }} <a href="mailto:contact@assuraf.com">contact@assuraf.com</a> , {{ $t('infos_legale.droit_acces_content[3]') }}
                </p>
            </v-flex>

            <v-flex xs12 sm12 md7 lg7 pa-2>
                <p class="headline text-assuraf policeLato pl-md-5 pt-3"><i class="title-border"></i>{{ $t('infos_legale.responsabilite_erreur_label') }}</p>
                <p class="text-justify subheading font-weight-normal">
                    ASSURAF {{ $t('infos_legale.responsabilite_erreur_content[0]') }} <br><br>{{ $t('infos_legale.responsabilite_erreur_content[1]') }}
                    <span>ASSURAF</span> {{ $t('infos_legale.responsabilite_erreur_content[2]') }}
                </p>
            </v-flex>

            <v-flex xs12 sm12 md7 lg7 pa-2>
                <p class="headline text-assuraf policeLato pl-md-5 pt-3"><i class="title-border"></i>{{ $t('infos_legale.plainte_label') }}
                </p>
                <p class="text-justify subheading font-weight-normal">
                    {{ $t('infos_legale.plainte_content[0]') }} <a
                        href="mailto:contact@assuraf.com">contact@assuraf.com</a>
                    ASSURAF {{ $t('infos_legale.plainte_content[1]') }}
                </p>
            </v-flex>

            <v-flex xs12 sm12 md7 lg7 pa-2>
                <p class="headline text-assuraf policeLato pl-md-5 pt-3"><i class="title-border"></i>{{ $t('infos_legale.notre_service_label') }}</p>
                <p class="text-justify subheading font-weight-normal">
                    <span>ASSURAF</span> {{ $t('infos_legale.notre_service_content[0]') }} <br><br>

                    <span>ASSURAF</span> {{ $t('infos_legale.notre_service_content[1]') }} <span>ASSURAF</span> {{ $t('infos_legale.notre_service_content[2]') }}
                </p>
            </v-flex>
            
              <v-flex xs12 sm12 md7 lg7 pa-2>
                <p class="headline text-assuraf policeLato pl-md-5 pt-3"><i class="title-border"></i>{{ $t('infos_legale.lutte_blanchiment_label') }}</p>
                <p class="text-justify subheading font-weight-normal">
                    {{ $t('infos_legale.lutte_blanchiment_content[0]') }} <a href="https://drive.google.com/file/d/10yCW8HdCzWeivWr_qKGCINA04nx11csP/view?usp=sharing" target="_blank"><span>{{ $t('infos_legale.lutte_blanchiment_content[1]') }} </span></a>, {{ $t('infos_legale.lutte_blanchiment_content[2]') }}  <br><br>
                    {{ $t('infos_legale.lutte_blanchiment_content[3]') }}  <br><br>

                    <ul style="list-style: disc;" class="ml-5">
                        <li>
                            {{ $t('infos_legale.lutte_blanchiment_content[4]') }}  <span>{{ $t('infos_legale.lutte_blanchiment_content[5]') }} </span> {{ $t('infos_legale.lutte_blanchiment_content[6]') }}  <span>{{ $t('infos_legale.lutte_blanchiment_content[7]') }} </span> {{ $t('infos_legale.lutte_blanchiment_content[8]') }} 
                        </li>
                        <li>
                            {{ $t('infos_legale.lutte_blanchiment_content[9]') }}  <span>{{ $t('infos_legale.lutte_blanchiment_content[10]') }} </span> {{ $t('infos_legale.lutte_blanchiment_content[11]') }}  <span>{{ $t('infos_legale.lutte_blanchiment_content[12]') }} </span> {{ $t('infos_legale.lutte_blanchiment_content[13]') }} 
                        </li>
                        <li>
                            {{ $t('infos_legale.lutte_blanchiment_content[14]') }}  <span>{{ $t('infos_legale.lutte_blanchiment_content[15]') }} </span>, {{ $t('infos_legale.lutte_blanchiment_content[16]') }}  <span>{{ $t('infos_legale.lutte_blanchiment_content[17]') }}</span>.
                        </li>
                        <li>
                            {{ $t('infos_legale.lutte_blanchiment_content[18]') }}  <span>{{ $t('infos_legale.lutte_blanchiment_content[19]') }} </span>, {{ $t('infos_legale.lutte_blanchiment_content[20]') }} 
                        </li>
                    </ul>
                    <br>
                    {{ $t('infos_legale.lutte_blanchiment_content[21]') }}  <span>Assuraf</span> {{ $t('infos_legale.lutte_blanchiment_content[22]') }} 
                </p>
            </v-flex>
        </v-layout>


        <!-- QUESTIONS FREQUENTES -->
       <v-layout v-responsive.lg.xl>
            <!-- FAQ SECTION -->
            <FaqSection></FaqSection>
        </v-layout>

        <v-layout v-responsive.sm.xs>
            <!-- FAQ SECTION -->
            <FaqSectionMobile></FaqSectionMobile>
        </v-layout>
    </v-container>
</template>

<script>
    import FaqSection from './apropos_component/faq_section_desktop.vue'
    import FaqSectionMobile from './apropos_component/faq_section_mobile.vue'
    export default {
        components: {
            FaqSection,
            FaqSectionMobile
        },
        data() {
            return {
                description: 'Assuraf – Infos Légales',
                HideDive: true,
                HideDive1: false,
                HideDive2: false,
                tabs: null,
                isHidden: true,
            }
        },
        metaInfo () {
            return {
                meta: [
                    { charset: 'utf-8' },
                    { name: 'keywords', content: 'infos legales, CGU'},
                    { hid: 'description', name: 'description', content: this.description}
                ]
            }
        },
        methods: {
            isMobile: function () {
                if (screen.width <= 760) {
                    return true;
                } else {
                    return false;
                }
            },
            isDesktop: function () {
                if (screen.width > 760) {
                    return true;
                } else {
                    return false;
                }
            },
            tabengclicked: function () {
                this.HideDive = false;
                this.HideDive1 = true;
                this.HideDive2 = false;
            },
            tabinovclicked: function () {
                this.HideDive = true;
                this.HideDive1 = false;
                this.HideDive2 = false;
            },
            tabresclicked: function () {
                this.HideDive = false;
                this.HideDive1 = false;
                this.HideDive2 = true;
            },
            toggle: function () {
                this.isHidden = !this.isHidden;
                if (this.isHidden === false) {
                    this.$refs.btnPlus.$el.innerText = 'Afficher Moins';
                } else if (this.isHidden === true) {
                    this.$refs.btnPlus.$el.innerText = 'Afficher Plus';
                }
            }
        },
        mounted(){
            window.scrollTo(0, 0);
        }
    }
</script>

<style scoped lang="less">
    @import "../assets/less/config";
    @import "../assets/css/devis_css.css";

    img {
        width: 100%;
        height: 300px;
    }

    .mamadou {
        width: 145px;
        height: 600px;
    }


    .article {
        /*margin-left: 7.5%;*/
        padding: 1%;
        text-align: justify;
        font-size: 16px;
        line-height: 30px;
        font-family: "Myriad Pro Regular" !important;
    }

    .img-box {
        width: 10%;
        height: 15%;
    }

    .text-sm-left {
        font-family: "Open-Sans" !important;
        font-size: 16px;
        padding: 2%;
        width: 498px;
    }

    .text-xs-right {
        font-family: "Open-Sans" !important;
        padding: 2%;
        padding-top: -1000px;
        margin-left: 700px;
        font-size: 16px;
        width: 498px;
    }

    /*notre equipe*/
    h2 {
        color: #333;
        text-align: center;
        text-transform: uppercase;
        font-family: "Open-Sans", sans-serif;
        font-weight: bold;
        position: relative;
        margin: 30px 0 60px;
    }


    .valeur .description {
        font-size: 14px;
        color: #FFFFFF;
        line-height: 26px;
        text-indent: 30px;
        position: relative;
        margin-top: -29px;
        margin-left: 450px;
    }

    .primary--text {
        font-family: Myriad Pro;
        font-weight: bold;
        color: #000000;
        font-size: 20px;

        .v-tabs__item {
            color: black;

        }

    }

    .col-center {
        margin: 0 auto;
        float: none !important;
    }

    .carousel {
        margin: 50px auto;
        padding: 0 70px;
    }

    .carousel .item {
        color: #999;
        font-size: 14px;
        text-align: center;
        overflow: hidden;
        min-height: 290px;
    }

    .carousel .item .img-box {
        width: 175px;
        height: 175px;
        margin: 0 auto;
        padding: 5px;
        border: 1px solid #ddd;
        border-radius: 50%;
    }

    .carousel .img-box img {
        width: 100%;
        height: 100%;
        display: block;
        border-radius: 50%;
    }

    .carousel .testimonial {
        padding: 30px 0 10px;
    }

    .carousel .overview {
        font-style: italic;
    }

    .carousel .overview b {
        text-transform: uppercase;
        color: #7AA641;
    }

    .carousel .carousel-control {
        width: 40px;
        height: 40px;
        margin-top: -20px;
        top: 50%;
        background: none;
    }

    .carousel-control i {
        font-size: 68px;
        line-height: 42px;
        position: absolute;
        display: inline-block;
        color: rgba(0, 0, 0, 0.8);
        text-shadow: 0 3px 3px #e6e6e6, 0 0 0 #000;
    }

    .carousel .carousel-indicators {
        bottom: -40px;
    }

    .carousel-indicators li, .carousel-indicators li.active {
        width: 10px;
        height: 10px;
        margin: 1px 3px;
        border-radius: 50%;
    }

    .carousel-indicators li {
        background: #999;
        border-color: transparent;
        box-shadow: inset 0 2px 1px rgba(0, 0, 0, 0.2);
    }

    .carousel-indicators li.active {
        background: #555;
        box-shadow: inset 0 2px 1px rgba(0, 0, 0, 0.2);
    }

    .text-assuraf {
        color: #ffa409;
    }

    .title-border {
        border-left: 5px solid #ffa409;
        padding-left: 0.6em;
        line-height: 0.5em;
    }

    span {
        font-weight: bold
    }

    strong {
        color: rgb(101, 101, 235);
        font-family: 'Times New Roman', Times, serif
    }

    .georgia {
        font-family: Georgia !important;
    }
    .policeLato {
      font-family: Lato, "Helvetica Neue", Arial, sans-serif;
    }
    .paralax-cover-image {
      background-image: url('../assets/img/assurance/cgv.jpg');
      position: relative;
      background-size: contain!important;
      background-position: 50%;
      min-height: 230px;
      width: 100%;
      margin: 0 0 0;
      display: flex;
      /*padding: 20px;*/
      align-items: center;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;

    }
    .paralax-cover-image p {
      color: rgb(255, 255, 255);
      font-size: 20px;
      font-weight: 300;
    }

    .paralax-cover-image .paralax-cover-image-text,
    .paralax-cover-image h2 {
      color: #fff;
      font-size: 2em;
      line-height: 1.25;
      z-index: 1;
      margin-bottom: 0;
      max-width: 610px;
      text-align: center;
      margin-left: 8.5%;
    }

    .paralax-cover-image.has-background-dim:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image {
      background-attachment: fixed;
      background-position: 50% 40px;
    }



    .paralax-cover-image_mobile {
      background-image: url('../assets/img/assurance/cgv_mobile.jpg');
      position: relative;
      background-size: contain;
      background-position: 50%;
      min-height: 150px;
      width: 100%;
      margin: 0 0 0;
      display: flex;
      //padding: 20px;
      align-items: center;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;

    }
    .paralax-cover-image_mobile p {
      color: rgb(255, 255, 255);
      font-size: 20px;
      font-weight: 300;
      padding-bottom: 20Px;
    }

    .paralax-cover-image_mobile .paralax-cover-image-text_mobile,
    .paralax-cover-image_mobile h2 {
      color: #fff;
      font-size: 2em;
      line-height: 1.25;
      z-index: 1;
      margin-bottom: 0;
      max-width: 610px;
      text-align: center;
      margin-left: 8.5%;
    }

    .paralax-cover-image_mobile.has-background-dim_mobile:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image_mobile {
    //   background-attachment: fixed;
      background-position: 50% 40px;
    }
</style>
